(function() {
  'use strict';

  // Simple configuration flag:
  // - true  => adding via Teeinblue will also open the cart drawer
  // - false => it will NOT open the cart drawer (but counts/bars still update)
  var OPEN_DRAWER_ON_TEEINBLUE_ADD = true;

  function setupTeeinblueBridge() {
    if (typeof window === 'undefined') return;
    if (!window.Shopify) return;

    // Preserve any existing handler
    var previousOnItemAdded = window.Shopify.onItemAdded;

    window.Shopify.onItemAdded = function(lineItem, cart) {
      // Call any existing handler first
      if (typeof previousOnItemAdded === 'function') {
        try {
          previousOnItemAdded.apply(this, arguments);
        } catch (e) {
          console.error('Error in previous Shopify.onItemAdded handler:', e);
        }
      }

      try {
        // Notify scripts that listen for the Shopify-style cart:updated event
        // (used by tiered progress bar + cart drawer shipping bar)
        try {
          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: cart || null,
            })
          );
        } catch (e) {
          console.error('Error dispatching cart:updated event:', e);
        }

        // Ask the Shapes theme to refresh cart sections & counters
        // This will trigger the theme's cart update pipeline and
        // ensure the cart drawer & cart count stay in sync.
        try {
          document.dispatchEvent(new Event('theme:update:cart'));
        } catch (e) {
          console.error('Error dispatching theme:update:cart event:', e);
        }

        // Optionally mirror the theme's native "item added" event so existing
        // listeners like the modal cart opener keep working.
        if (OPEN_DRAWER_ON_TEEINBLUE_ADD === true) {
          try {
            // The theme opens the modal cart by listening on document.body for
            // the "shapes:cart:afteradditem" event, so we must dispatch it
            // from the same target.
            var targetEl = document.body || document;
            targetEl.dispatchEvent(
              new CustomEvent('shapes:cart:afteradditem', {
                bubbles: true,
                detail: {
                  // Include cart if available so any listeners that inspect
                  // the payload have something useful.
                  response: cart || null,
                },
              })
            );
          } catch (e) {
            console.error('Error dispatching shapes:cart:afteradditem event:', e);
          }
        }
      } catch (e) {
        console.error('Error in Shopify.onItemAdded bridge handler:', e);
      }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupTeeinblueBridge);
  } else {
    setupTeeinblueBridge();
  }
})();


